module.exports = __webpack_public_path__ + "img/hiclipart15.d8c131ad.png";